import { createClient } from '@supabase/supabase-js'

// These are public client-side keys. 
// They allow the app to talk to Supabase, but NOT to Postmark directly.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://eruskoakbogooniwjmof.supabase.co'
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVydXNrb2FrYm9nb29uaXdqbW9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAwNTMwMjAsImV4cCI6MjA4NTYyOTAyMH0.XPfyNvZi5cDD4Eb8TVQNbIwEUAWqYBpNyEn1Q_Fmu3c'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})